import { MarkEmailReadOutlined } from '@mui/icons-material';
import { Box, Container, Link, Paper, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import AffiliateHeader from '../../components/AffiliateHeader';

const VerifyEmailPending: React.FC = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Box sx={{ mb: 4 }}>
          <AffiliateHeader />
        </Box>
        <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
          <MarkEmailReadOutlined color="primary" sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Check your email
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            We've sent a verification link{email ? ` to ${email}` : ''}. You can log in and apply
            to the affiliate program right away — verifying your email just keeps your account
            secure.
          </Typography>
          <Link component={RouterLink} to="/login" underline="none">
            Go to login
          </Link>
        </Paper>
      </Box>
    </Container>
  );
};

export default VerifyEmailPending;
